export const entityNamesByKey: Record<keyof typeof DataKeys, string> = {
  // OpenCloud
  RegionsMetadata: 'Regions Metadata',
  AllTenantDefaultVolumeTypes: 'All Tenant Default Volume Types',
  TenantDefaultVolumeTypes: 'Tenant Default Volume Types',
  AddonVersions: 'Addon Versions',
  AlertRules: 'Alert Rules',
  Alerts: 'Alerts',
  AlertsTimeSeries: 'Alerts History',
  AllClusters: 'Clusters',
  ApiEndpoints: 'Available Api Endpoints',
  ApiGroups: 'Api Groups',
  ApiResources: 'Api Group Resources',
  AppDetails: 'App Details',
  Apps: 'Apps',
  AppsAvailableToCluster: 'Cluster Apps',
  CloudProviderDetails: 'Cloud Provider Details',
  CloudProviderRegionDetails: 'Cloud Provider Regions',
  CloudProviders: 'Cloud Providers',
  ClusterAddons: 'Cluster Addons',
  ClusterRoleBindings: 'Cluster Role Bindings',
  ClusterRoles: 'Cluster Roles',
  PrometheusInstances: 'Prometheus Instances',
  ServiceAccounts: 'Service Accounts',
  PrometheusRules: 'Prometheus Rules',
  PrometheusServiceMonitors: 'Prometheus Service Monitors',
  PrometheusAlertManagers: 'Prometheus Alert Managers',
  StorageClasses: 'Storage Classes',
  CSIDrivers: 'CSI Drivers',
  PersistentVolumes: 'Persistent Volumes',
  PersistentVolumeClaims: 'Persistent Volume Claims',
  Silences: 'Alert Silences',
  Ssh: 'SSH Keys',
  ServiceCatalog: 'Service Catalog',
  Clusters: 'Clusters',
  CoreApiResources: 'Api Resources',
  DeployedAppDetails: 'Deployed App Details',
  DeployedApps: 'Deployed Apps',
  Deployments: 'Deployments',
  Flavors: 'Flavors',
  ImportedClusters: 'Imported Clusters',
  Ingresses: 'Ingresses',
  KubeRoles: 'Kube Roles',
  KubeServiceDetails: 'Kube Service Details',
  // KubeServices: 'Kube Services',
  ManagementCredentials: 'MFA Credentials',
  ManagementGroups: 'SSO Groups',
  ManagementGroupsMappings: 'SSO Group Mappings',
  ManagementRoles: 'Tenant Roles',
  ManagementTenants: 'Tenants',
  AllTenants: 'All Tenants',
  ManagementTenantsRoleAssignments: 'Tenant Role Assignments',
  ManagementUsers: 'Users',
  FederatedDomainUsers: 'Federated Domain Users',
  ManagementUsersRoleAssignments: 'User Role Assignments',
  Namespaces: 'Namespaces',
  Nodes: 'Nodes',
  K8sNodes: 'K8s Nodes',
  PodMetrics: 'Pod Metrics',
  Pods: 'Pods',
  RbacProfileBindings: 'RBAC Profile Bindings',
  RbacProfiles: 'RBAC Profiles',
  Regions: 'Regions',
  Repositories: 'Repositories',
  RepositoriesForCluster: 'Cluster Repositories',
  ResMgrHosts: 'Node Resources',
  RoleBindings: 'Role Bindings',
  SupportedRoleVersions: 'K8s Versions',
  EksVersions: 'EKS Versions',
  AwsRegionInfo: 'AWS Region Info',
  Tenants: 'Tenants',
  UserTenants: 'User Tenants',
  Domains: 'Domains',
  ConfigMaps: 'Config Maps',
  Users: 'Users',
  VirtualMachineDetails: 'Virtual Machine Details',
  VirtualMachines: 'Virtual Machines',
  VirtualMachineInstances: 'Virtual Machine Instances',
  VirtualMachinePresets: 'Virtual Machine Presets',
  Networks: 'Networks',
  DataVolumes: 'Data Volumes',
  Events: 'Events',
  CapiEvents: 'CAPI Events',
  PodLogs: 'Pod Logs',
  Cronjobs: 'Cron Jobs',
  Jobs: 'Jobs',
  StatefulSets: 'Stateful Sets',
  ReplicaSets: 'Replica Sets',
  DaemonSets: 'Daemon Sets',
  MonitoringAddons: 'Monitoring Addons',
  KubevirtAddons: 'Kubevirt Addons',
  NetworkingAddons: 'Networking Addons',
  ClusterAgents: 'Cluster Agents',
  CapiClusters: 'CAPI Clusters',
  CapiAwsClusters: 'CAPI AWS Clusters',
  NodeletControlPlanes: 'Nodelet Control Planes',
  AwsAmis: 'AWS AMIs',
  CapiHosts: 'CAPI Hosts',
  AwsClusterRoleIdentities: 'AWS Cluster Role Identities',
  AwsManagedControlPlanes: 'AWS Managed Control Planes',
  MachineDeployments: 'Machine Deployments',
  MachinePools: 'Machine Pools',
  AwsManagedMachinePools: 'AWS Managed Machine Pools',
  AwsMachineTemplates: 'Machine Templates',
  NodeletConfigs: 'Nodelet Configs',
  NodeletConfigTemplates: 'NodeletConfigTemplates',
  EksConfigs: 'EKS Configs',
  EksConfigTemplates: 'EksConfigTemplates',
  AwsMachinePools: 'AWS Machine Pools',
  AwsClusterStaticIdentities: 'AWS Cluster Static Identities',
  ClusterVersions: 'Cluster Versions',
  LiveMigrations: 'Live Migrations',
  ClusterUpgradeJobs: 'Cluster Upgrade Jobs',
  EksAmiTypes: 'EKS AMI Types',
  InstanceTypes: 'Instancetypes',
  ClusterInstanceTypes: 'Cluster Instancetypes',
  EksAddons: 'EksAddons',
  IpAllocations: 'IP Allocations',
  NetworkPlugins: 'Plugins Configurations',
  HostNetworkTemplates: 'Host Configurations',
  Secrets: 'Secrets',
  Images: 'Images',
  Blueprints: 'Blueprints',
  ImageMembers: 'Image Members',
  OpenstackVirtualMachines: 'VM Instances',
  AllOpenstackVirtualMachines: 'VM Instances',
  SingleOpenstackVirtualMachine: 'VM Instance',
  SelfOpenstackVirtualMachines: 'VM Instances',
  // Lite VM List
  OpenstackVirtualMachinesLite: 'VM Instances',
  AllOpenstackVirtualMachinesLite: 'VM Instances',
  SelfOpenstackVirtualMachinesLite: 'VM Instances',
  OpenstackStatewiseVirtualMachinesLite: 'VM Instances',
  AllOpenstackStatewiseVirtualMachinesLite: 'Active VM Instances',
  SelfOpenstackStatewiseVirtualMachinesLite: 'VM Instances',
  OpenstackNetworks: 'Networks',
  OpenstackSubnets: 'Subnets',
  OpenstackPorts: 'Ports',
  OpenstackAllAvailablePorts: 'Available Ports',
  OpenstackRouters: 'Routers',
  OpenstackVolumes: 'Volumes',
  AllOpenstackVolumes: 'Volumes',
  SingleOpenstackVolume: 'Volume',
  OpenstackVolumesLite: 'Volumes',
  NonPaginatedOpenstackVolumes: 'Volumes',
  OpenstackVolumesForImages: 'Volumes For Images',
  AvailableOpenstackVolumes: 'Volumes',
  VolumeTransfers: 'Volume Transfers',
  AllVolumeTransfers: 'Volume Transfers',
  OpenstackVolumeSnapshots: 'Volume Snapshots',
  CinderMessages: 'Cinder Messages',
  CinderMessagesForVolume: 'Cinder Messages For Volume',
  CinderMessage: 'Cinder Message',
  NetworkIpAvailability: 'Network Availability',
  NetworkRBACPolicies: 'Network RBAC Policies',
  ResmgrHosts: 'Cluster Hosts',
  Hypervisors: 'Hypervisors',
  AllocationCandidates: 'Allocation Candidates',
  SshKeys: 'SSH Keys',
  FloatingIps: 'Public IPs',
  SecurityGroups: 'Security Groups',
  VolumeTypes: 'Volume Types',
  HostAggregates: 'Host Aggregates',
  Stacks: 'Stacks',
  AvailabilityZones: 'Availability Zones',
  ComputeServiceDetails: 'Compute Service Details',
  StorageServiceDetails: 'Storage Service Details',
  NetworkServiceDetails: 'Network Service Details',
  MetadataServiceHealth: 'Metadata Service Health',
  BrokenMetadataNetworks: 'Broken Metadata Networks',
  ImageServiceDetails: 'Image Service Details',
  ServerGroups: 'Server Groups',
  AllServerGroups: 'Server Groups',
  StoragePools: 'Storage Pools',
  HostNetworkConfigs: 'Host Network Configurations',
  ResourcePlacement: 'Resource Placement',
  DnsPools: 'DNS Pools',
  DnsZones: 'DNS Zones',
  DnsRecords: 'DNS Records',
  LoadBalancers: 'Load Balancers',
  Repository: 'Repository',
  Templates: 'Templates',
  TerraformModule: 'Terraform Module',
  RepositoryBranches: 'Repository Branches',
  Applications: 'Applications',
  ApplicationDetails: 'Application Details',
  MyApps: 'My Apps',
  OctaviaFlavors: 'Octavia Flavors',
  OctaviaListeners: 'Octavia Listeners',
  OctaviaPools: 'Octavia Pools',
  OctaviaPoolMembers: 'Octavia Pool Members',
  OctaviaHealthMonitors: 'Octavia Health Monitors',
  ClusterHostGroups: 'Cluster Host Groups',
  ClusterVMHAStatus: 'Cluster VMHA Status',
  DatabaseClusters: 'Database Clusters',
  LeasePolicies: 'Lease Policies',
  Leases: 'Leases',
  SsoAttributes: 'SsoAttributes',
  ControlPlaneServicesHealth: 'Control Plane Services Health',
  VmMigrations: 'Migrations',
  ApplicationCredentials: 'Application Credentials',

  // Kaapi
  KaapiClusters: 'Kaapi Clusters',
  KaapiHostedControlPlanes: 'Kaapi Control Planes',
  KaapiKubeadmControlPlanes: 'Kaapi Kubeadm Control Planes',
  KaapiOpenStackMachineTemplates: 'Kaapi OpenStack Machine Templates',
  KaapiOpenStackServers: 'Kaapi OpenStack Servers',
  KaapiEvents: 'Kaapi Events',
  KaapiKubeadmConfigTemplates: 'Kubeadm Config Templates',
  KaapiMachineDeployments: 'Kaapi Machine Deployments',
  KaapiClusterAddons: 'Kaapi Cluster Add-ons',
  KaapiTenants: 'Kaapi Tenants',
  KaapiMachines: 'Kaapi Machines',
  KaapiClusterUpgradeJobs: 'Kaapi Cluster Upgrade Jobs',
  KaapiConfigMaps: 'Kaapi Config Maps',
  KaapiSecrets: 'Kaapi Secrets',
  KaapiBYOHosts: 'Kaapi BYOHosts',
  KaapiBYOMachines: 'Kaapi BYOMachines',
  KaapiBYOClusters: 'Kaapi BYOClusters',
  KaapiBYOMachineTemplates: 'Kaapi BYOMachineTemplates',
  KaapiK8sInstallerConfigTemplates: 'Kaapi K8s Installer Config Templates',
  // Workload Clusters
  KaapiNodes: 'Kaapi Nodes',
  KaapiNodesAllClusters: 'Kaapi Nodes All Clusters',
  KaapiMetricsNodes: 'Kaapi Metrics Nodes',
  KaapiMetricsNodesAllClusters: 'Kaapi Metrics Nodes All Clusters',
  CustomResourceDefinitions: 'Custom Resource Definitions',
  CustomResources: 'Custom Resources',
  Capabilities: 'Capabilities',
}

enum DataKeys {
  AddonVersions = 'AddonVersions',
  AllTenantDefaultVolumeTypes = 'AllTenantDefaultVolumeTypes',
  AlertRules = 'AlertRules',
  Alerts = 'Alerts',
  AlertsTimeSeries = 'AlertsTimeSeries',
  AllClusters = 'AllClusters',
  ApiEndpoints = 'ApiAccessEndpoints',
  ApiGroups = 'ApiGroups',
  ApiResources = 'ApiResources',
  AppDetails = 'AppDetails',
  Apps = 'Apps',
  AppsAvailableToCluster = 'AppsAvailableToCluster',
  CloudProviderDetails = 'CloudProviderDetails',
  CloudProviderRegionDetails = 'CloudProviderRegionDetails',
  CloudProviders = 'CloudProviders',
  ClusterAddons = 'ClusterAddons',
  ClusterRoleBindings = 'ClusterRoleBindings',
  ClusterRoles = 'ClusterRoles',
  PrometheusInstances = 'PrometheusInstances',
  ServiceAccounts = 'ServiceAccounts',
  PrometheusRules = 'PrometheusRules',
  PrometheusServiceMonitors = 'PrometheusServiceMonitors',
  PrometheusAlertManagers = 'PrometheusAlertManagers',
  StorageClasses = 'StorageClasses',
  CSIDrivers = 'CSIDrivers',
  PersistentVolumes = 'PersistentVolumes',
  PersistentVolumeClaims = 'PersistentVolumeClaims',
  Silences = 'Silences',
  Ssh = 'Ssh',
  ServiceCatalog = 'ServiceCatalog',
  Clusters = 'Clusters',
  CoreApiResources = 'CoreApiResources',
  DeployedAppDetails = 'DeployedAppDetails',
  DeployedApps = 'DeployedApps',
  Deployments = 'Deployments',
  Flavors = 'Flavors',
  ImportedClusters = 'ImportedClusters',
  Ingresses = 'Ingresses',
  KubeRoles = 'KubeRoles',
  KubeServiceDetails = 'KubeServiceDetails',
  // KubeServices = 'KubeServices',
  ManagementCredentials = 'ManagementCredentials',
  ManagementGroups = 'ManagementGroups',
  ManagementGroupsMappings = 'ManagementGroupsMappings',
  ManagementRoles = 'ManagementRoles',
  ManagementTenants = 'ManagementTenants',
  AllTenants = 'AllTenants',
  ManagementTenantsRoleAssignments = 'ManagementTenantsRoleAssignments',
  ManagementUsers = 'ManagementUsers',
  FederatedDomainUsers = 'FederatedDomainUsers',
  ManagementUsersRoleAssignments = 'ManagementUsersRoleAssignments',
  Namespaces = 'Namespaces',
  Nodes = 'Nodes',
  PodMetrics = 'PodMetrics',
  Pods = 'Pods',
  RbacProfileBindings = 'RbacProfileBindings',
  RbacProfiles = 'RbacProfiles',
  Regions = 'Regions',
  Repositories = 'Repositories',
  RepositoriesForCluster = 'RepositoriesForCluster',
  ResMgrHosts = 'ResMgrHosts',
  RoleBindings = 'RoleBindings',
  SupportedRoleVersions = 'SupportedRoleVersions',
  EksVersions = 'EksVersions',
  AwsRegionInfo = 'AwsRegionInfo',
  Tenants = 'Tenants',
  UserTenants = 'UserTenants',
  Domains = 'Domains',
  ConfigMaps = 'ConfigMaps',
  Users = 'Users',
  VirtualMachineDetails = 'VirtualMachineDetails',
  VirtualMachines = 'VirtualMachines',
  VirtualMachineInstances = 'VirtualMachineInstances',
  VirtualMachinePresets = 'VirtualMachinePresets',
  Networks = 'Networks',
  DataVolumes = 'DataVolumes',
  Events = 'Events',
  CapiEvents = 'CapiEvents',
  PodLogs = 'PodLogs',
  MonitoringAddons = 'MonitoringAddons',
  KubevirtAddons = 'KubevirtAddons',
  NetworkingAddons = 'NetworkingAddons',
  K8sNodes = 'K8sNodes',
  StatefulSets = 'StatefulSets',
  ReplicaSets = 'ReplicaSets',
  Cronjobs = 'Cronjobs',
  Jobs = 'Jobs',
  DaemonSets = 'DaemonSets',
  ClusterAgents = 'ClusterAgents',
  CapiClusters = 'CapiClusters',
  CapiAwsClusters = 'CapiAwsClusters',
  NodeletControlPlanes = 'NodeletControlPlanes',
  AwsAmis = 'AwsAmis',
  AwsClusterRoleIdentities = 'AwsClusterRoleIdentities',
  AwsManagedControlPlanes = 'AwsManagedControlPlanes',
  CapiHosts = 'CapiHosts',
  MachineDeployments = 'MachineDeployments',
  AwsMachineTemplates = 'AwsMachineTemplates',
  NodeletConfigs = 'NodeletConfigs',
  NodeletConfigTemplates = 'NodeletConfigTemplates',
  EksConfigs = 'EksConfigs',
  EksConfigTemplates = 'EksConfigTemplates',
  MachinePools = 'MachinePools',
  AwsMachinePools = 'AwsMachinePools',
  AwsManagedMachinePools = 'AwsManagedMachinePools',
  AwsClusterStaticIdentities = 'AwsClusterStaticIdentities',
  ClusterVersions = 'ClusterVersions',
  LiveMigrations = 'LiveMigrations',
  ClusterUpgradeJobs = 'ClusterUpgradeJobs',
  EksAmiTypes = 'EksAmiTypes',
  InstanceTypes = 'InstanceTypes',
  ClusterInstanceTypes = 'ClusterInstanceTypes',
  EksAddons = 'EksAddons',
  IpAllocations = 'IpAllocations',
  NetworkPlugins = 'NetworkPlugins',
  HostNetworkTemplates = 'HostNetworkTemplates',
  Secrets = 'Secrets',
  Images = 'Images',
  Blueprints = 'Blueprints',
  ImageMembers = 'ImageMembers',
  OpenstackVirtualMachines = 'OpenstackVirtualMachines',
  AllOpenstackVirtualMachines = 'AllOpenstackVirtualMachines',
  SingleOpenstackVirtualMachine = 'SingleOpenstackVirtualMachine',
  SelfOpenstackVirtualMachines = 'SelfOpenstackVirtualMachines',
  // Lite VM List
  OpenstackVirtualMachinesLite = 'OpenstackVirtualMachinesLite',
  AllOpenstackVirtualMachinesLite = 'AllOpenstackVirtualMachinesLite',
  SelfOpenstackVirtualMachinesLite = 'SelfOpenstackVirtualMachinesLite',
  OpenstackStatewiseVirtualMachinesLite = 'OpenstackStatewiseVirtualMachinesLite',
  AllOpenstackStatewiseVirtualMachinesLite = 'AllOpenstackStatewiseVirtualMachinesLite',
  SelfOpenstackStatewiseVirtualMachinesLite = 'SelfOpenstackStatewiseVirtualMachinesLite',
  OpenstackNetworks = 'OpenstackNetworks',
  OpenstackSubnets = 'OpenstackSubnets',
  OpenstackPorts = 'OpenstackPorts',
  OpenstackAllAvailablePorts = 'OpenstackAllAvailablePorts',
  OpenstackRouters = 'OpenstackRouters',
  OpenstackVolumes = 'OpenstackVolumes',
  AllOpenstackVolumes = 'AllOpenstackVolumes',
  SingleOpenstackVolume = 'SingleOpenstackVolume',
  OpenstackVolumesLite = 'OpenstackVolumesLite',
  NonPaginatedOpenstackVolumes = 'NonPaginatedOpenstackVolumes',
  OpenstackVolumesForImages = 'OpenstackVolumesForImages',
  AvailableOpenstackVolumes = 'AvailableOpenstackVolumes',
  VolumeTransfers = 'VolumeTransfers',
  AllVolumeTransfers = 'AllVolumeTransfers',
  OpenstackVolumeSnapshots = 'OpenstackVolumeSnapshots',
  CinderMessages = 'CinderMessages',
  CinderMessagesForVolume = 'CinderMessagesForVolume',
  CinderMessage = 'CinderMessage',
  NetworkIpAvailability = 'NetworkIpAvailability',
  NetworkRBACPolicies = 'NetworkRBACPolicies',
  ResmgrHosts = 'ResmgrHosts',
  Hypervisors = 'Hypervisors',
  AllocationCandidates = 'AllocationCandidates',
  SshKeys = 'SshKeys',
  FloatingIps = 'FloatingIps',
  SecurityGroups = 'SecurityGroups',
  VolumeTypes = 'VolumeTypes',
  HostAggregates = 'HostAggregates',
  ResourcePlacement = 'ResourcePlacement',
  Stacks = 'Stacks',
  AvailabilityZones = 'AvailabilityZones',
  ComputeServiceDetails = 'ComputeServiceDetails',
  StorageServiceDetails = 'StorageServiceDetails',
  NetworkServiceDetails = 'NetworkServiceDetails',
  MetadataServiceHealth = 'MetadataServiceHealth',
  BrokenMetadataNetworks = 'BrokenMetadataNetworks',
  ImageServiceDetails = 'ImageServiceDetails',
  ServerGroups = 'ServerGroups',
  AllServerGroups = 'AllServerGroups',
  StoragePools = 'StoragePools',
  HostNetworkConfigs = 'HostNetworkConfigs',
  DnsPools = 'DnsPools',
  DnsZones = 'DnsZones',
  DnsRecords = 'DnsRecords',
  LoadBalancers = 'LoadBalancers',
  Repository = 'Repository',
  Templates = 'Templates',
  TerraformModule = 'TerraformModule',
  RepositoryBranches = 'RepositoryBranches',
  Applications = 'Applications',
  ApplicationDetails = 'ApplicationDetails',
  MyApps = 'MyApps',
  OctaviaFlavors = 'OctaviaFlavors',
  OctaviaListeners = 'OctaviaListeners',
  OctaviaPools = 'OctaviaPools',
  OctaviaPoolMembers = 'OctaviaPoolMembers',
  OctaviaHealthMonitors = 'OctaviaHealthMonitors',
  ClusterHostGroups = 'ClusterHostGroups',
  ClusterVMHAStatus = 'ClusterVMHAStatus',
  DatabaseClusters = 'DatabaseClusters',
  LeasePolicies = 'LeasePolicies',
  Leases = 'Leases',
  SsoAttributes = 'SsoAttributes',
  TenantDefaultVolumeTypes = 'TenantDefaultVolumeTypes',
  VmMigrations = 'VmMigrations',
  ApplicationCredentials = 'ApplicationCredentials',

  // Kaapi
  KaapiClusters = 'KaapiClusters',
  KaapiHostedControlPlanes = 'KaapiHostedControlPlanes',
  KaapiKubeadmControlPlanes = 'KaapiKubeadmControlPlanes',
  KaapiOpenStackMachineTemplates = 'KaapiOpenStackMachineTemplates',
  KaapiOpenStackServers = 'KaapiOpenStackServers',
  KaapiEvents = 'KaapiEvents',
  KaapiKubeadmConfigTemplates = 'KaapiKubeadmConfigTemplates',
  KaapiMachineDeployments = 'KaapiMachineDeployments',
  KaapiClusterAddons = 'KaapiClusterAddons',
  KaapiTenants = 'KaapiTenants',
  KaapiMachines = 'KaapiMachines',
  KaapiClusterUpgradeJobs = 'KaapiClusterUpgradeJobs',
  KaapiConfigMaps = 'KaapiConfigMaps',
  KaapiSecrets = 'KaapiSecrets',
  KaapiBYOHosts = 'KaapiBYOHosts',
  KaapiBYOMachines = 'KaapiBYOMachines',
  KaapiBYOClusters = 'KaapiBYOClusters',
  KaapiBYOMachineTemplates = 'KaapiBYOMachineTemplates',
  KaapiK8sInstallerConfigTemplates = 'KaapiK8sInstallerConfigTemplates',
  // Workload Clusters
  KaapiNodes = 'KaapiNodes',
  KaapiNodesAllClusters = 'KaapiNodesAllClusters',
  KaapiMetricsNodes = 'KaapiMetricsNodes',
  KaapiMetricsNodesAllClusters = 'KaapiMetricsNodesAllClusters',
  CustomResourceDefinitions = 'CustomResourceDefinitions',
  CustomResources = 'CustomResources',
  ControlPlaneServicesHealth = 'ControlPlaneServicesHealth',

  // OpenCloud
  RegionsMetadata = 'RegionsMetadata',
  Capabilities = 'Capabilities',
}

export default DataKeys

// TODO: Remove this when we move everything to TS, enums aren't supported in JS
export const ActionDataKeys = {
  AddonVersions: 'AddonVersions',
  AlertRules: 'AlertRules',
  Alerts: 'Alerts',
  AlertsTimeSeries: 'AlertsTimeSeries',
  AllClusters: 'AllClusters',
  ApiEndpoints: 'ApiAccessEndpoints',
  ApiGroups: 'ApiGroups',
  ApiResources: 'ApiResources',
  AppDetails: 'AppDetails',
  Apps: 'Apps',
  AppsAvailableToCluster: 'AppsAvailableToCluster',
  CloudProviderDetails: 'CloudProviderDetails',
  CloudProviderRegionDetails: 'CloudProviderRegionDetails',
  CloudProviders: 'CloudProviders',
  ClusterAddons: 'ClusterAddons',
  ClusterRoleBindings: 'ClusterRoleBindings',
  ClusterRoles: 'ClusterRoles',
  PrometheusInstances: 'PrometheusInstances',
  ServiceAccounts: 'ServiceAccounts',
  PrometheusRules: 'PrometheusRules',
  PrometheusServiceMonitors: 'PrometheusServiceMonitors',
  PrometheusAlertManagers: 'PrometheusAlertManagers',
  StorageClasses: 'StorageClasses',
  CSIDrivers: 'CSIDrivers',
  PersistentVolumes: 'PersistentVolumes',
  PersistentVolumeClaims: 'PersistentVolumeClaims',
  Silences: 'Silences',
  Ssh: 'Ssh',
  ServiceCatalog: 'ServiceCatalog',
  Clusters: 'Clusters',
  CoreApiResources: 'CoreApiResources',
  DeployedAppDetails: 'DeployedAppDetails',
  DeployedApps: 'DeployedApps',
  Deployments: 'Deployments',
  Flavors: 'Flavors',
  ImportedClusters: 'ImportedClusters',
  Ingresses: 'Ingresses',
  KubeRoles: 'KubeRoles',
  KubeServiceDetails: 'KubeServiceDetails',
  // KubeServices: 'KubeServices',
  ManagementCredentials: 'ManagementCredentials',
  ManagementGroups: 'ManagementGroups',
  ManagementGroupsMappings: 'ManagementGroupsMappings',
  ManagementGroupsRoleAssignments: 'ManagementGroupsRoleAssignments',
  ManagementRoles: 'ManagementRoles',
  ManagementTenants: 'ManagementTenants',
  AllTenants: 'AllTenants',
  ManagementTenantsRoleAssignments: 'ManagementTenantsRoleAssignments',
  ManagementUsers: 'ManagementUsers',
  FederatedDomainUsers: 'FederatedDomainUsers',
  ManagementUsersRoleAssignments: 'ManagementUsersRoleAssignments',
  Namespaces: 'Namespaces',
  Nodes: 'Nodes',
  PodMetrics: 'PodMetrics',
  Pods: 'Pods',
  RbacProfileBindings: 'RbacProfileBindings',
  RbacProfiles: 'RbacProfiles',
  Regions: 'Regions',
  Repositories: 'Repositories',
  RepositoriesForCluster: 'RepositoriesForCluster',
  ResMgrHosts: 'ResMgrHosts',
  RoleBindings: 'RoleBindings',
  SupportedRoleVersions: 'SupportedRoleVersions',
  EksVersions: 'EKS Versions',
  AwsRegionInfo: 'AWS Region Info',
  Tenants: 'Tenants',
  UserTenants: 'UserTenants',
  Domains: 'Domains',
  ConfigMaps: 'ConfigMaps',
  Users: 'Users',
  VirtualMachineDetails: 'VirtualMachineDetails',
  VirtualMachines: 'VirtualMachines',
  VirtualMachineInstances: 'VirtualMachineInstances',
  VirtualMachinePresets: 'VirtualMachinePresets',
  Networks: 'Networks',
  DataVolumes: 'DataVolumes',
  Events: 'Events',
  CapiEvents: 'CapiEvents',
  PodLogs: 'PodLogs',
  MonitoringAddons: 'MonitoringAddons',
  KubevirtAddons: 'KubevirtAddons',
  NetworkingAddons: 'NetworkingAddons',
  K8sNodes: 'K8sNodes',
  StatefulSets: 'StatefulSets',
  ReplicaSets: 'ReplicaSets',
  Cronjobs: 'Cronjobs',
  Jobs: 'Jobs',
  DaemonSets: 'DaemonSets',
  CapiClusters: 'CapiClusters',
  CapiAwsClusters: 'CapiAwsClusters',
  NodeletControlPlanes: 'NodeletControlPlanes',
  AwsClusterRoleIdentities: 'AwsClusterRoleIdentities',
  AwsManagedControlPlanes: 'AwsManagedControlPlanes',
  CapiHosts: 'CapiHosts',
  MachineDeployments: 'MachineDeployments',
  MachinePools: 'MachinePools',
  AwsManagedMachinePools: 'AwsManagedMachinePools',
  AwsMachineTemplates: 'AwsMachineTemplates',
  NodeletConfigs: 'NodeletConfigs',
  NodeletConfigTemplates: 'NodeletConfigTemplates',
  EksConfigs: 'EksConfigs',
  EksConfigTemplates: 'EksConfigTemplates',
  AwsMachinePools: 'AwsMachinePools',
  AwsClusterStaticIdentities: 'AwsClusterStaticIdentities',
  LiveMigrations: 'LiveMigrations',
  ClusterUpgradeJobs: 'ClusterUpgradeJobs',
  EksAmiTypes: 'EksAmiTypes',
  InstanceTypes: 'InstanceTypes',
  ClusterInstanceTypes: 'ClusterInstanceTypes',
  EksAddons: 'EksAddons',
  IpAllocations: 'IpAllocations',
  NetworkPlugins: 'NetworkPlugins',
  HostNetworkTemplates: 'HostNetworkTemplates',
  Secrets: 'Secrets',
  Images: 'Images',
  Blueprints: 'Blueprints',
  OpenstackVirtualMachines: 'OpenstackVirtualMachines',
  AllOpenstackVirtualMachines: 'AllOpenstackVirtualMachines',
  SingleOpenstackVirtualMachine: 'SingleOpenstackVirtualMachine',
  SelfOpenstackVirtualMachines: 'SelfOpenstackVirtualMachines',
  AllTenantDefaultVolumeTypes: 'AllTenantDefaultVolumeTypes',

  // Lite VM List
  OpenstackVirtualMachinesLite: 'OpenstackVirtualMachinesLite',
  AllOpenstackVirtualMachinesLite: 'AllOpenstackVirtualMachinesLite',
  SelfOpenstackVirtualMachinesLite: 'SelfOpenstackVirtualMachinesLite',
  OpenstackStatewiseVirtualMachinesLite: 'OpenstackStatewiseVirtualMachinesLite',
  AllOpenstackStatewiseVirtualMachinesLite: 'AllOpenstackStatewiseVirtualMachinesLite',
  SelfOpenstackStatewiseVirtualMachinesLite: 'SelfOpenstackStatewiseVirtualMachinesLite',
  OpenstackNetworks: 'OpenstackNetworks',
  OpenstackSubnets: 'OpenstackSubnets',
  OpenstackPorts: 'OpenstackPorts',
  OpenstackAllAvailablePorts: 'OpenstackAllAvailablePorts',
  OpenstackRouters: 'OpenstackRouters',
  OpenstackVolumes: 'OpenstackVolumes',
  AllOpenstackVolumes: 'AllOpenstackVolumes',
  SingleOpenstackVolume: 'SingleOpenstackVolume',
  OpenstackVolumesLite: 'OpenstackVolumesLite',
  NonPaginatedOpenstackVolumes: 'NonPaginatedOpenstackVolumes',
  OpenstackVolumesForImages: 'OpenstackVolumesForImages',
  AvailableOpenstackVolumes: 'AvailableOpenstackVolumes',
  VolumeTransfers: 'VolumeTransfers',
  AllVolumeTransfers: 'AllVolumeTransfers',
  OpenstackVolumeSnapshots: 'OpenstackVolumeSnapshots',
  CinderMessages: 'CinderMessages',
  CinderMessagesForVolume: 'CinderMessagesForVolume',
  CinderMessage: 'CinderMessage',
  NetworkIpAvailability: 'NetworkIpAvailability',
  NetworkRBACPolicies: 'NetworkRBACPolicies',
  ResmgrHosts: 'ResmgrHosts',
  Hypervisors: 'Hypervisors',
  AllocationCandidates: 'AllocationCandidates',
  SshKeys: 'SshKeys',
  FloatingIps: 'FloatingIps',
  SecurityGroups: 'SecurityGroups',
  VolumeTypes: 'VolumeTypes',
  HostAggregates: 'HostAggregates',
  Stacks: 'Stacks',
  AvailabilityZones: 'AvailabilityZones',
  ComputeServiceDetails: 'ComputeServiceDetails',
  StorageServiceDetails: 'StorageServiceDetails',
  NetworkServiceDetails: 'NetworkServiceDetails',
  MetadataServiceHealth: 'MetadataServiceHealth',
  BrokenMetadataNetworks: 'BrokenMetadataNetworks',
  ImageServiceDetails: 'ImageServiceDetails',
  ServerGroups: 'ServerGroups',
  AllServerGroups: 'AllServerGroups',
  StoragePools: 'StoragePools',
  HostNetworkConfigs: 'HostNetworkConfigs',
  DnsPools: 'DnsPools',
  DnsZones: 'DnsZones',
  DnsRecords: 'DnsRecords',
  LoadBalancers: 'LoadBalancers',
  Repository: 'Repository',
  Templates: 'Templates',
  TerraformModule: 'TerraformModule',
  RepositoryBranches: 'RepositoryBranches',
  Applications: 'Applications',
  ApplicationDetails: 'ApplicationDetails',
  MyApps: 'MyApps',
  OctaviaFlavors: 'OctaviaFlavors',
  OctaviaListeners: 'OctaviaListeners',
  OctaviaPools: 'OctaviaPools',
  OctaviaPoolMembers: 'OctaviaPoolMembers',
  OctaviaHealthMonitors: 'OctaviaHealthMonitors',
  ClusterHostGroups: 'ClusterHostGroups',
  ClusterVMHAStatus: 'ClusterVMHAStatus',
  DatabaseClusters: 'Database Clusters',
  LeasePolicies: 'Lease Policies',
  Leases: 'Leases',
  SsoAttributes: 'SsoAttributes',
  VmMigrations: 'Migrations',
  ApplicationCredentials: 'ApplicationCredentials',

  // Kaapi
  KaapiClusters: 'KaapiClusters',
  KaapiHostedControlPlanes: 'KaapiHostedControlPlanes',
  KaapiOpenStackMachineTemplates: 'KaapiOpenStackMachineTemplates',
  KaapiOpenStackServers: 'KaapiOpenStackServers',
  KaapiKubeadmConfigTemplates: 'KaapiKubeadmConfigTemplates',
  KaapiMachineDeployments: 'KaapiMachineDeployments',
  KaapiClusterAddons: 'KaapiClusterAddons',
  KaapiTenants: 'KaapiTenants',
  KaapiMachines: 'KaapiMachines',
  KaapiClusterUpgradeJobs: 'KaapiClusterUpgradeJobs',
  KaapiConfigMaps: 'KaapiConfigMaps',
  KaapiSecrets: 'KaapiSecrets',
  KaapiBYOHosts: 'KaapiBYOHosts',
  KaapiBYOMachines: 'KaapiBYOMachines',
  KaapiBYOClusters: 'KaapiBYOClusters',
  KaapiBYOMachineTemplates: 'KaapiBYOMachineTemplates',
  KaapiK8sInstallerConfigTemplates: 'KaapiK8sInstallerConfigTemplates',
  // Workload Clusters
  KaapiNodes: 'KaapiNodes',
  KaapiNodesAllClusters: 'KaapiNodesAllClusters',
  KaapiMetricsNodes: 'KaapiMetricsNodes',
  KaapiMetricsNodesAllClusters: 'KaapiMetricsNodesAllClusters',
  CustomResourceDefinitions: 'CustomResourceDefinitions',
  CustomResources: 'CustomResources',

  // OpenCloud
  RegionsMetadata: 'RegionsMetadata',
  Capabilities: 'Capabilities',
}
